import '../css/app.css'


import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

import 'preline';

import '@splidejs/splide/css';
import Splide from '@splidejs/splide';
import { Video } from '@splidejs/splide-extension-video';
import '@splidejs/splide-extension-video/dist/css/splide-extension-video.min.css';

import 'lazysizes';

import Swup from 'swup';
import SwupScriptsPlugin from '@swup/scripts-plugin';

import { Observer } from 'tailwindcss-intersect';
 


const swup = new Swup({
  plugins: [new SwupScriptsPlugin()]
});

// // Run once when page loads
if (document.readyState === 'complete') {
  init();
} else {
  document.addEventListener('DOMContentLoaded', () => init());
}
// Run after every additional navigation by swup
swup.hooks.on('page:view', () => init());


function init() {
var sliders = document.getElementsByClassName( 'imageVideoSlider' );

for ( var i = 0; i < sliders.length; i++ ) {
  new Splide( sliders[ i ], {
    arrowPath: 'M28.5357 19.2929C28.9262 19.6834 28.9262 20.3166 28.5357 20.7071L22.1717 27.0711C21.7812 27.4616 21.148 27.4616 20.7575 27.0711C20.367 26.6805 20.367 26.0474 20.7575 25.6569L26.4144 20L20.7575 14.3431C20.367 13.9526 20.367 13.3195 20.7575 12.9289C21.148 12.5384 21.7812 12.5384 22.1717 12.9289L28.5357 19.2929ZM10 19L27.8286 19V21L10 21V19Z',
    lazyLoad: false,
    autoWidth: true,
    video: {
      autoplay: true,
      controls: false,
      mute: true,
      playerOptions: {
        htmlVideo: {
          controls: false,
          playsInline: true,
          loop: true,
          preload: true,
          muted: true,
        },
      },
    },
  } ).mount( { Video } );
}

var carousels = document.getElementsByClassName( 'imageCarousel' );

for ( var i = 0; i < carousels.length; i++ ) {
  new Splide( carousels[ i ], {
    arrowPath: 'M0.292894 7.2929C-0.0976315 7.68342 -0.0976314 8.31658 0.292894 8.70711L6.65686 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928934C7.68054 0.538409 7.04738 0.538409 6.65685 0.928934L0.292894 7.2929ZM26 8L26 7L1 7L1 8L1 9L26 9L26 8Z',
    lazyLoad: false,
    padding: { left: '20%', right: '20%' },
    breakpoints: {
      640: {
        perPage: 1,
        padding: 0,
      },
      768: {
        perPage: 2,
        padding: 0,
      },
    },
  } ).mount();
}

// // Parallax effect for blob elements
// function initParallax() {
//   const parallaxElements = document.querySelectorAll('.blob-parallax');
  
//   if (parallaxElements.length === 0) return;
  
//   function updateParallax() {
//     parallaxElements.forEach(element => {
//       const rect = element.getBoundingClientRect();
//       const elementCenter = rect.top + rect.height / 2;
//       const viewportCenter = window.innerHeight / 2;
//       const distance = elementCenter - viewportCenter;
//       const speed = parseFloat(element.dataset.parallaxSpeed) || 0.5;
//       const offset = distance * speed;
      
//       element.style.transform = `translate(-50%, calc(-50% + ${offset}px))`;
//     });
//   }
  
//   window.addEventListener('scroll', updateParallax, { passive: true });
//   window.addEventListener('resize', updateParallax, { passive: true });
//   updateParallax();
// }


// initParallax();

// Initialize Preline tooltips after Swup page load
// window.HSTooltip.autoInit();
}

// Components
Alpine.plugin(collapse);

// Global
window.Alpine = Alpine;

// Inits
Alpine.start();
Observer.start();

